export default "__VITE_ASSET__DTQqD0qW__"